import React, {Component} from 'react';
import $ from "jquery";
import PropTypes from 'prop-types';


class LeftMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            main_menu_class_o : 'ind-menu ',
            main_menu_class_v : 'ind-menu ',
            main_menu_class_g : 'ind-menu ',
            main_menu_class_p : 'ind-menu ',
            main_menu_class_u : 'ind-menu ',
            anchor_class_g : 'toggle-click ',
            anchor_class_a : 'toggle-click ',
            anchor_class_v : 'toggle-click ',
            gtoggler_class : 'toggle-opener-block'

        };

    }

    componentDidMount() {
       // $('.toggle-opener-block').slideUp();
        $('.menu-block').on("click",function(e) {
           // e.preventDefault();
            e.stopPropagation();
            $(this).closest('.ind-menu1').toggleClass('active');
            $(this).closest('.ind-menu1').find('.toggle-opener-block').slideToggle();

            var url = $(this).data('rel');
            if(url) {
                window.location = url;
            }


        });

        let main_menu_class_o = this.state.main_menu_class_o;
        let main_menu_class_v = this.state.main_menu_class_v;
        let main_menu_class_g = this.state.main_menu_class_g;
        let main_menu_class_p = this.state.main_menu_class_p;
        let main_menu_class_u = this.state.main_menu_class_u;
        let anchor_class_g = this.state.anchor_class_g;
        let anchor_class_a = this.state.anchor_class_a;
        let anchor_class_v = this.state.anchor_class_v;

        let gtoggler_class = this.state.gtoggler_class;

        if(this.props.pageName === 'OVERVIEW'){
            main_menu_class_o += ' active';
        }
        else if(this.props.pageName === 'VIGNETS' || this.props.pageName === 'VIGDETAIL'){
            main_menu_class_v += ' active';
        }
        else if(this.props.pageName === 'MY_UPLOADS'){
            anchor_class_g += ' active';
            main_menu_class_g += ' active';
            gtoggler_class += ' show';
        }else if( this.props.pageName === 'AUDIO'){
            anchor_class_a += ' active';
            main_menu_class_g += ' active';
            gtoggler_class += ' show';
        }else if( this.props.pageName === 'VIDEO') {
            anchor_class_v += ' active';
            main_menu_class_g += ' active';
            gtoggler_class += ' show';
        }else if(this.props.pageName === 'PLAYLIST'  || this.props.pageName === 'PLAYLISTDETAIL'){
            main_menu_class_p += ' active';
        }
        else if(this.props.pageName === 'USER'){
            main_menu_class_u += ' active';
        }



        this.setState({main_menu_class_o : main_menu_class_o, main_menu_class_v : main_menu_class_v, main_menu_class_g : main_menu_class_g, main_menu_class_p : main_menu_class_p, main_menu_class_u : main_menu_class_u, anchor_class_g : anchor_class_g,anchor_class_a : anchor_class_a,anchor_class_v : anchor_class_v, gtoggler_class : gtoggler_class });


    }

    render() {
        return (

            <div className="side-content-area">
                <ul className="side-menu-list">
                    <li className= {this.state.main_menu_class_o}>
                        <a href="#/overview" className="menu-block">
                            <span className="icon-lib overview-ico"></span>
                            <span className="menu-text">Overview</span>
                        </a>
                    </li>
                    <li className= {this.state.main_menu_class_v}>
                        <a href="#/vignets" className="menu-block">
                            <span className="icon-lib manage-ico"></span>
                            <span className="menu-text">Vignets</span>
                        </a>
                    </li>
                    <li className="ind-menu1">
                        <a href="javascript:;" className="menu-block" data-rel="#/gallery">
                            <span className="icon-lib resource-ico"></span>
                            <span className="menu-text">Gallery</span>
                        </a>
                        <div className={this.state.gtoggler_class}>
                            <ul className="toggle-opener">
                                <li>
                                    <a href="#/gallery" className={this.state.anchor_class_g}>Graphics</a>
                                </li>
                                <li>
                                    <a href="#/audio" className={this.state.anchor_class_a}>Audio</a>
                                </li>
                                <li>
                                    <a href="#/video" className={this.state.anchor_class_v}>Video</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li className= {this.state.main_menu_class_p}>
                        <a href="#/playlists" className="menu-block">
                            <span className="icon-lib ply-ico"></span>
                            <span className="menu-text ply-menu-text">Playlist</span>
                        </a>
                    </li>
                    <li className= {this.state.main_menu_class_u}>
                        <a href="#/users" className="menu-block">
                            <span className="icon-lib admin-ico"></span>
                            <span className="menu-text">User</span>
                        </a>
                    </li>
                </ul>
            </div>

        );
    }
}

LeftMenu.propTypes = {
    pageName: PropTypes.string
}

export default LeftMenu;


// WEBPACK FOOTER //
// ./src/components/common/LeftMenu.js